import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const AddStaff = ({ setResponse }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    pass: '',
    role: '',
    permission: []
  });

  // const permissionsList = ['Inventory', 'Coupons', 'Add Party', 'User Management', 'Add Purchase', 'Purchase History'];
  const permissionsList = [
  'Inventory',
  'Coupons',
  'User Management',
  'Reports'
];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedPermissions = checked
        ? [...prev.permission, value]
        : prev.permission.filter((perm) => perm !== value);

      return { ...prev, permission: updatedPermissions };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const dataToSend = {
      ...formData,
      permission: JSON.stringify(formData.permission)
    };

    try {
      const res = await fetch('https://api.hargharmart.com/add-staff', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      if (!res.ok) throw new Error('Failed to add staff');

      setFormData({
        name: '',
        mobile: '',
        pass: '',
        role: '',
        permission: []
      });

      setResponse({ message: 'Staff Added successfully.', status: 'success' });
      setTimeout(() => setResponse(''), 2000);
    } catch (error) {
      setResponse({ message: 'Failed to add staff.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className='my-4'>
        <div className='px-4'>
          <div className='d-flex justify-content-between'>
            <p className='page-title'>Add New Staff</p>
            <button className='close-btn' onClick={() => navigate('/manage-staff')}>Go Back</button>
          </div>

          <form className="row g-3 bg-white rounded-2 mt-3 pb-3" onSubmit={handleSubmit}>
            <div className="col-md-6">
              <label htmlFor="name" className="profile-label">Staff Name</label>
              <input
                type="text"
                className="product-control"
                id="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="mobile" className="profile-label">Mobile</label>
              <input
                type="tel"
                className="product-control"
                id="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="role" className="profile-label">Role</label>
              <input
                type="text"
                className="product-control"
                id="role"
                value={formData.role}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="pass" className="profile-label">Password</label>
              <input
                type="text"
                className="product-control"
                id="pass"
                value={formData.pass}
                onChange={handleChange}
              />
            </div>

            {/* <div className="col-12">
              <label className="profile-label">Permissions</label>
              <div className="d-flex flex-wrap gap-3">
                {permissionsList.map((perm) => (
                  <div key={perm} className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={perm}
                      id={`perm-${perm}`}
                      checked={formData.permission.includes(perm)}
                      onChange={handleCheckboxChange}
                    />
                    <label className="form-check-label" htmlFor={`perm-${perm}`}>
                      {perm.charAt(0).toUpperCase() + perm.slice(1)}
                    </label>
                  </div>
                ))}
              </div>
            </div> */}
            <div className="col-12">
  <label className="profile-label">Permissions</label>

  <div className="d-flex flex-wrap gap-3">
    {permissionsList.map((perm) => (
      <div key={perm} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          value={perm}
          id={`perm-${perm}`}
          checked={formData.permission.includes(perm)}
          onChange={handleCheckboxChange}
        />

        <label
          className="form-check-label"
          htmlFor={`perm-${perm}`}
        >
          {perm}
        </label>
      </div>
    ))}
  </div>
</div>

            <div className="col-12 text-end">
              <button type="submit" className="edit-btn">
                Submit Details
              </button>
            </div>
          </form>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default AddStaff;
